import useAxiosInstance from "./axiosInstance";
import { useCallback} from 'react';


const useGetUserData = (navigate) => {
  const axiosInstance = useAxiosInstance(navigate);

  const getUserData = useCallback(async () => {
    try {
      const response = await axiosInstance.get(`/me`);
      return response.data;
    } catch (error) {
      console.error("Error retrieving user information:", error);
      throw error;
    }
  }, [axiosInstance]);

  return getUserData;
};

export default useGetUserData;